import { useTenant } from './useTenant';

export function useSuperAdmin() {
  const { isSuperAdmin, isLoadingMe } = useTenant();

  return {
    isSuperAdmin,
    isLoading: isLoadingMe,
  };
}
